
import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceDic from "@/views/字典管理/service/DZServiceDic";
import DZModelPage from "@/model/DZModelPage";
import nyMessageToast from "@/utils/NYMessageToast";
import DZModelDicType from "@/views/字典管理/model/DZModelDicType";
import dzMsgBox from "@/utils/DZMessageBox";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    is_dialog_show = false;

    is_edit = false;

    m_page = new DZModelPage(10);

    s_dic = new DZServiceDic();

    search = "";

    created() {
        this.action_list_data()
        this.s_dic.net_list_label()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    dialog_init(){
        this.s_dic.m_type = new DZModelDicType();
    }

    dialog_close(){
        this.is_dialog_show = false
        this.dialog_init()
    }
    /**
     * 查
     */
    action_list_data(){
        this.s_dic.net_page_list_type(this.m_page)
    }
    /**
     * 增
     */
    action_open_dialog(){
        this.is_edit = false
        this.is_dialog_show = true
    }
    action_add_type(){
        if(this.s_dic.m_type.name.nyIsEmpty()){
            nyMessageToast.warning("请输入分类名称");
            return;
        }
        this.s_dic.net_add_type(this.action_list_data)
        this.dialog_close()
    }

    /**
     * 改
     * @param row
     */
    handle_edit(row){
        this.is_edit = true
        this.s_dic.m_type = Object.assign({},row)
        this.is_dialog_show = true
    }
    action_edit_type(){
        if(this.s_dic.m_type.name.nyIsEmpty()){
            nyMessageToast.warning("请输入分类名称");
            return;
        }
        this.s_dic.net_edit_type(this.action_list_data)
        this.dialog_close();
    }

    /**
     * 删
     */
    action_delete_type(row){
        dzMsgBox.del("是否删除该信息？", () => {
            this.s_dic.net_delete_type(row.id,() => {
                this.action_list_data()
            });
        })
    }

    /** =============================================================== **/

    handle_add_dic(row){
        this.$router.push({ path: "/dic/list", query: { id: row.id,name:row.name ,father: this.$route.path } })
    }

    handleDbClick(row){
        if(row.id){
            this.handle_edit(row)
        }
    }
}
